import Vue from "vue";
import moment from "moment";

Vue.filter("date", (value, format = "DD.MM.YYYY") => moment(value).format(format));
Vue.filter("dateFromEpoch", value => new Date(value * 1000));
